export class ArrayUtils {
  static isEmpty(array: Array<any>) {
    return !array || array.length === 0;
  }
}
